





















import { defineComponent } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';

import type { Disclaimer } from '@/graphql/generated';

export default defineComponent({
  name: 'ShowsDisclaimer',
  components: {
  },
  props: {
    disclaimer: {
      type: Object as PropType<Disclaimer>,
      required: true,
    },
  },
});
